import React from 'react';
import TopStatusItem from './TopStatusItem';
import onlinePeopleIcon from '../../../../assets/images/ai/topBar/onlinePeople.png';
import taskIcon from '../../../../assets/images/ai/topBar/task.png';
import timeIcon from '../../../../assets/images/ai/topBar/time.png';
import pointIcon from '../../../../assets/images/ai/topBar/point.png';

interface TopStatusBarProps {
  className?: string;
}

const TopStatusBar: React.FC<TopStatusBarProps> = ({ className }) => {
  return (
    <div className={`fixed top-0 left-0 right-0 z-[1000] px-5 py-3 bg-transparent ${className}`}>
      <div className="flex gap-3 items-center justify-start md:gap-3 sm:gap-2">
        <TopStatusItem
          icon={<img src={onlinePeopleIcon} alt="online people" className="w-7 h-7" />}
          value="08"
          iconColor="#000000"
        />
        <TopStatusItem
          icon={<img src={taskIcon} alt="task" className="w-7 h-7" />}
          value="05"
          iconColor="#000000"
        />
        <TopStatusItem
          icon={<img src={timeIcon} alt="time" className="w-8 h-8" />}
          value="5h23m"
          iconColor="#000000"
        />
        <TopStatusItem
          icon={<img src={pointIcon} alt="point" className="w-7 h-7" />}
          value="1745"
          iconColor="#000000"
        />
      </div>
    </div>
  );
};



export default TopStatusBar;